import { SVC_A } from './base'

/**
 * Accesses events for a given domain.
 *
 * @export
 * @param {String} domainUUID The domain ID look up events for.
 * @param {any} params Params to append to the URL.
 * @returns An array of credentials.
 */

export function getCredentialsByDomainUUID (domainUUID) {
  return SVC_A.get(`/api/faces/v1/credentials?domain_uuid=${domainUUID}`)
}

/**
 * Fetch the event history for a given identity.
 *
 * @export
 * @param {any} credentialUUID The UUID if the credential ID to fetch history for.
 * @param {any} params The parameters to pass the server.
 * @returns A list of events for the given identity.
 */
export function getCredentialHistoryForCredentialUUID (credentialUUID, params) {
  let paramString = ''
  if (params) {
    params.map((option, index) => {
      const prefix = index === 0 ? '?' : '&'
      paramString += `${prefix}${option}`
    })
  }

  return SVC_A.get(
    `/api/faces/v1/credentials/${credentialUUID}/access-events${paramString}`
  )
}

/**
 * Update the tags for an access event.
 *
 * @export
 * @param {any} confirmedUUIDs The dection UUIDs of the faces to mark as confirmed.
 * @returns A promise.
 */

export function updateAccessEventCredentials (confirmedDetections, domainUUID) {
  if (!confirmedDetections.length) {
    return new Promise((resolve, reject) => resolve({ data: { ok: true } }))
  }
  return SVC_A.post(
    `/api/faces/v1/confirmed_tags?domain_uuid=${domainUUID}`,
    confirmedDetections
  )
}

export function rejectConfirmedTags (rejectedDetections, domainUUID) {
  return SVC_A.delete(
    `/api/faces/v1/confirmed_tags?domain_uuid=${domainUUID}`,
    rejectedDetections
  )
}

export function getConfirmedTagsforIdentity (domainUUID, identityId) {
  return SVC_A.get(
    `/api/faces/v1/confirmed_tags?domain_uuid=${domainUUID}&identity_id=${identityId}`
  )
}

export function getCredentialUseScore (domainUUID, identityId) {
  return SVC_A.get(
    `/api/faces/v1/credentials/${identityId}/score?domain_uuid=${domainUUID}`
  )
}

export function downloadAccessEventReport (domainUUID, target, format) {
  let responseFormat = format ? `&format=${format}` : ''
  // if target is exactly 16 chars, it is a hashed identity
  let reportTarget = target.length === 16 ? `identity_id=${target}` : `unit=${target}`
  return SVC_A.download(
    `/api/faces/v1/credentials/report?domain_uuid=${domainUUID}&${reportTarget}${responseFormat}`
  )
}

export function createNewIdentity (identity) {
  return SVC_A.post('/api/faces/v1/identities/', identity)
}

export function editIdentity (identity, identityId) {
  return SVC_A.patch(`/api/faces/v1/identities/${identityId}`, identity)
}

export function getRealtimeCredentialMatches (domainUUID) {
  return SVC_A.get(`/api/faces/v1/realtime_credentials?domain_uuid=${domainUUID}`)
}
